import UserInfo from './user_info'

export default {
    install: function(Vue) {
        Vue.component('UserInfo', UserInfo)
    }
}
